/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid, Typography, Divider, Paper } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";
import DropDownSelect from "../../../../components/DropDownSelect/DropDownSelect";
import { SERVICES } from "../../../../components/Layout/Services";
import { SERVICES as MasterDataServices } from "../../../../components/Layout/Services/MasterDataServices";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

function AdvancedSearch({
  clearValues,
  onAmountChangeFrom,
  onAmountChangeTo,
  onDataEnterdBy,
  setAdvancedSearchValues,
  amountFromValue,
  amountToValue,
  updateSortingMethod,
}) {
  const [payableCity, setPayableCity] = useState([]);
  const [selectedPayableCity, setSelectedPayableCity] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState([]);
  const [receiptType, setReceiptType] = useState([]);
  const [selectedReceiptType, setSelectedReceiptType] = useState([]);
  const [uinType, setUinType] = useState([]);
  const [selectedUinType, setSelectedUinType] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [newSelectedData, setNewSelectedData] = useState("");
  const [profileData, setProfileData] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const sortFields = [
    { value: "fullName", label: "Name" },
    { value: "orderId", label: "Order ID" },
    { value: "updatedAt", label: "Contribution Date" },
  ];

  const sortOrders = [
    { value: "ASC", label: "Ascending" },
    { value: "DESC", label: "Descending" },
  ];

  const [selectedSortField, setSelectedSortField] = useState("");
  const [selectedSortOrder, setSelectedSortOrder] = useState("");

  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handlePaymentMethod = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_METHODS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const paymentMethodVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setPaymentMethods(paymentMethodVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handlePayableCity = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYABLE_CITIES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const payableFormattedPos = data.data.map((d) => ({
          entityTitle: d.cityName,
          value: d.cityName,
        }));
        setPayableCity(payableFormattedPos);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handlePaymentGateway = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYMENT_GATEWAYS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const paymentGatewayVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setPaymentGateway(paymentGatewayVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleReceiptType = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const receiptTypesVal = data.data.receiptTypes.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setReceiptType(receiptTypesVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleUinType = async () => {
    try {
      const url = `${MasterDataServices.GET_UIN_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        const uinTypeVal = data.data.map((d) => ({
          entityTitle: d.name,
          value: d.name,
        }));
        setUinType(uinTypeVal);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const handleDataEnterBy = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER}/adminSearch?page=0&size=100&roleIds=22&roleIds=23`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setSelectedData(data?.data?.content);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    handlePaymentMethod();
    handlePayableCity();
    handlePaymentGateway();
    handleReceiptType();
    handleUinType();
    handleDataEnterBy();
  }, []);

  useEffect(() => {
    setAdvancedSearchValues((prevValues) => ({
      ...prevValues,
      selectedPayableCity,
      selectedPaymentMethod:
        profileData?.assignedRoles?.includes("contributionOfflineDataEntry") &&
        selectedPaymentMethod.length === 0
          ? ["CASH", "CHEQUE", "DEMAND_DRAFT"]
          : selectedPaymentMethod,
      selectedPaymentGateway,
      selectedReceiptType,
      selectedUinType,
      newSelectedData,
    }));
  }, [
    selectedPayableCity,
    selectedPaymentMethod,
    selectedPaymentGateway,
    selectedUinType,
    selectedReceiptType,
    newSelectedData,
    profileData,
  ]);

  useEffect(() => {
    getUserRole();
  }, []);

  useEffect(() => {
    if (clearValues) {
      setSelectedPaymentGateway([]);
      setSelectedPaymentMethod([]);
      setSelectedUinType([]);
      setSelectedReceiptType([]);
    }
  }, [clearValues]);

  useEffect(() => {
    const sortOrder = selectedSortOrder || "ASC";
    const sortField = selectedSortField || "fullName";
    updateSortingMethod(`${sortField},${sortOrder}`);
  }, [selectedSortField, selectedSortOrder]);

  useEffect(() => {
    if (queryParams.get("paymentGatewayTypes") === null) {
      setSelectedPaymentGateway([]);
    }
    if (queryParams.get("paymentMethodTypes") === null) {
      setSelectedPaymentMethod([]);
    }
    if (queryParams.get("uinTypes") === null) {
      setSelectedUinType([]);
    }
    if (queryParams.get("receiptType") === null) {
      setSelectedReceiptType([]);
    }
  }, [
    queryParams.get("paymentGatewayTypes"),
    queryParams.get("paymentMethodTypes"),
    queryParams.get("uinTypes"),
    queryParams.get("receiptType"),
  ]);

  const isAdmin = profileData?.assignedRoles?.includes("contributionAdmin");
  const isDataEntry = profileData?.assignedRoles?.includes(
    "contributionDataEntry"
  );
  const showAdminFields = isAdmin || isDataEntry;

  return (
    <Paper elevation={0}>
      <Grid container rowSpacing={3} columnSpacing={3}>
        {/* Payment Gateway */}
        {showAdminFields && (
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <DropDownSelect
                title="Payment Gateway"
                multiple
                selectOptions={paymentGateway}
                value={selectedPaymentGateway}
                setValue={setSelectedPaymentGateway}
                style={{ maxWidth: "100%" }}
                className="dropdown-multiple"
              />
            </Box>
          </Grid>
        )}

        {/* Payment Method */}
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              p: 2,
              backgroundColor: "#fff",
              borderRadius: 1,
              border: "1px solid #e0e0e0",
              height: "100%",
            }}
          >
            <DropDownSelect
              title="Payment Method"
              multiple
              selectOptions={paymentMethods}
              value={selectedPaymentMethod}
              setValue={setSelectedPaymentMethod}
              style={{ maxWidth: "100%" }}
              className="dropdown-multiple"
            />
          </Box>
        </Grid>

        {/* Amount Range */}
        {showAdminFields && (
          <>
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  border: "1px solid #e0e0e0",
                }}
              >
                <InputField
                  label="Amount From"
                  name="amountFrom"
                  value={amountFromValue}
                  onChange={(event) => {
                    const { value } = event.target;
                    onAmountChangeFrom(value);
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  border: "1px solid #e0e0e0",
                }}
              >
                <InputField
                  label="Amount To"
                  name="amountTo"
                  value={amountToValue}
                  onChange={(event) => {
                    const { value } = event.target;
                    onAmountChangeTo(value);
                  }}
                />
              </Box>
            </Grid>
          </>
        )}

        {/* UIN Type */}
        {showAdminFields && (
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <DropDownSelect
                title="UIN Type"
                multiple
                selectOptions={uinType}
                value={selectedUinType}
                setValue={setSelectedUinType}
                style={{ maxWidth: "100%" }}
                className="dropdown-multiple"
              />
            </Box>
          </Grid>
        )}

        {/* Data Entered By */}
        {isAdmin && (
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <AutoCompleteDropdown
                getOptionLabel={(option) => option.fullName}
                options={getOptions(selectedData, "memberId")}
                label="Data Entered by"
                value={newSelectedData}
                onChange={(selectedValue) => {
                  onDataEnterdBy(selectedValue?.value);
                  setNewSelectedData(selectedValue?.value);
                }}
                useHiddenInput
                style={{ maxWidth: "100%" }}
              />
            </Box>
          </Grid>
        )}

        {/* Receipt Type */}
        {showAdminFields && (
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
                height: "100%",
              }}
            >
              <DropDownSelect
                title="Receipt Type"
                multiple
                selectOptions={receiptType}
                value={selectedReceiptType}
                setValue={setSelectedReceiptType}
                style={{ maxWidth: "100%" }}
                className="dropdown-multiple"
              />
            </Box>
          </Grid>
        )}
      </Grid>

      {/* Sorting Section */}
      <Box sx={{ mt: 4 }}>
        <Divider sx={{ mb: 3 }} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
              }}
            >
              <AutoCompleteDropdown
                options={sortFields.map((field) => ({
                  value: field.value,
                  label: field.label,
                }))}
                label="Sort Field"
                value={selectedSortField}
                onChange={(selectedValue) => {
                  setSelectedSortField(selectedValue?.value);
                }}
                inputProps={{ required: false }}
                useHiddenInput
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fff",
                borderRadius: 1,
                border: "1px solid #e0e0e0",
              }}
            >
              <AutoCompleteDropdown
                options={sortOrders.map((order) => ({
                  value: order.value,
                  label: order.label,
                }))}
                label="Sort Order"
                value={selectedSortOrder}
                onChange={(selectedValue) => {
                  setSelectedSortOrder(selectedValue?.value);
                }}
                inputProps={{ required: false }}
                useHiddenInput
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}

export default AdvancedSearch;
